import * as React from 'react';
import { Input, InputGroup, UIHeading4, InputAdornment } from '@cian/ui-kit';

import * as styles from './InputsMultiple.css';

interface IInputProps extends React.HTMLProps<HTMLInputElement> {
  onChangeValue(value: string): void;
  rightAdornment?: React.ReactNode;
}

export interface IInputsMultipleProps extends React.HTMLProps<HTMLInputElement> {
  label: string;
  stack: IInputProps[];
  onChange?(e: React.ChangeEvent<HTMLInputElement>): void;
}

export function InputsMultiple(props: IInputsMultipleProps) {
  const { stack, label } = props;

  return (
    <div className={styles['field']}>
      <UIHeading4>{label}</UIHeading4>
      <div className={styles['stack']}>
        <InputGroup>
          {stack.map((stackProps, index) => {
            const handleChange = (_e: React.ChangeEvent<HTMLInputElement>, value?: string) =>
              stackProps.onChangeValue(value || '');

            return (
              <Input
                key={index}
                type="number"
                size="M"
                disabled={props.disabled}
                placeholder={stackProps.placeholder}
                value={stackProps.value ? String(stackProps.value) : ''}
                aria-label={stackProps['aria-label']}
                onChange={handleChange}
                rightAdornment={<InputAdornment>{stackProps.rightAdornment}</InputAdornment>}
              />
            );
          })}
        </InputGroup>
      </div>
    </div>
  );
}
